enum OrderStatus {
    PENDING_PAYMENT = "PENDING_PAYMENT",

    PENDING_SHIPMENT = "PENDING_SHIPMENT",

    SHIPPED = "SHIPPED",

    SUCCESS = "SUCCESS",

    CANCELED = "CANCELED",
}

export default OrderStatus;
